import { SvgIcon, SvgIconProps } from "@mui/material";

export const ArticleIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path
      d="M9 17.75C8.9 17.75 8.81 17.73 8.71 17.69C8.43 17.58 8.25 17.3 8.25 17V11C8.25 10.59 8.59 10.25 9 10.25C9.41 10.25 9.75 10.59 9.75 11V15.19L10.47 14.47C10.76 14.18 11.24 14.18 11.53 14.47C11.82 14.76 11.82 15.24 11.53 15.53L9.53 17.53C9.39 17.67 9.19 17.75 9 17.75Z"
      fill="black"
    />
    <path
      d="M8.99945 17.7495C8.80945 17.7495 8.61945 17.6795 8.46945 17.5295L6.46945 15.5295C6.17945 15.2395 6.17945 14.7595 6.46945 14.4695C6.75945 14.1795 7.23945 14.1795 7.52945 14.4695L9.52945 16.4695C9.81945 16.7595 9.81945 17.2395 9.52945 17.5295C9.37945 17.6795 9.18945 17.7495 8.99945 17.7495Z"
      fill="black"
    />
    <path
      d="M15 22.75H9C3.57 22.75 1.25 20.43 1.25 15V9C1.25 3.57 3.57 1.25 9 1.25H14C14.41 1.25 14.75 1.59 14.75 2C14.75 2.41 14.41 2.75 14 2.75H9C4.39 2.75 2.75 4.39 2.75 9V15C2.75 19.61 4.39 21.25 9 21.25H15C19.61 21.25 21.25 19.61 21.25 15V10C21.25 9.59 21.59 9.25 22 9.25C22.41 9.25 22.75 9.59 22.75 10V15C22.75 20.43 20.43 22.75 15 22.75Z"
      fill="black"
    />
    <path
      d="M22 10.7505H18C14.58 10.7505 13.25 9.42048 13.25 6.00048V2.00048C13.25 1.70048 13.43 1.42048 13.71 1.31048C13.99 1.19048 14.31 1.26048 14.53 1.47048L22.53 9.47048C22.74 9.68048 22.81 10.0105 22.69 10.2905C22.57 10.5705 22.3 10.7505 22 10.7505ZM14.75 3.81048V6.00048C14.75 8.58048 15.42 9.25048 18 9.25048H20.19L14.75 3.81048Z"
      fill="black"
    />
  </SvgIcon>
);
